import React from 'react';
import './AboutApp.css'

const AboutApp = () => {
    const services = [
        {
            title: 'Pay Suppliers Securely',
            imgPath: '/img/wallet.svg',
            description: 'Purchase goods, services and products simply within the app, the app helps you control your budget.'
        },
        {
            title: 'Chat With Businesses',
            imgPath: '/img/chat.svg',
            description: 'Chat directly with your suppliers, receive photos and notifications in real-time.'
        },
        {
            title: 'View Services & Products',
            imgPath: '/img/cart.svg',
            description: 'Businesses related to your party or event are presented within your events location, find numerous businesses on the app.'
        },
        {
            title: 'Rent, Hire, Buy Products & Services',
            imgPath: '/img/birthday.svg',
            description: 'With Elite Partyz, you can buy, rent & hire everything from cakes, decorations through to hiring limousines & event venues..'
        },
    ]
    return (
        // === About App section ===
        <div className="about-app-section">
            <div className="container">
                <div className="about-app-content">
                    {/* === Left side images === */}
                    <div className="about-app-left">
                        <div className="img-1">
                            <img src="/img/bg-logo.webp" alt="About app" />
                        </div>
                        <div className="img-2">
                            <img src="/img/about-app.webp" alt="About app" />
                        </div>
                    </div>
                    {/* === About app right content === */}
                    <div className="about-app-right">
                        <h1 className="invisible-heading">ABOUT</h1>
                        <h2 className="visible-heading"><span className="highlight">About</span> <span>Elite Partyz App</span></h2>
                        <div className="separetor-ul"></div>
                        <p className="description">The features you can access are next level and essential when it comes to Party & Event planning. Have suppliers and businesses at your finger tips based on your event location and event type. </p>
                        <div className="about-services">
                            
                            {
                                /* === Service item loop === */
                                services.map((service, index) => {
                                    return(
                                        <div className="services-item" key={`SERVICE${index}`}>
                                            <img className="service-icon" src={service.imgPath} alt="" />
                                            <h4 className="title">{service.title}</h4>
                                            <p className="description">{service.description}</p>
                                        </div>
                                    )
                                })
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutApp
